import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { quickAlertsUrl } from "../../config";
import { Status } from "../../common/constants";
import api from '../../api';
import { RootState } from "../../store";
import { IAlertActionPayload } from "../../common/types/alertsTypes";
import { IInitialSliceState } from "../../common/types/commonTypes";

const ALERT_ACTION: string = "alertAction"

const initialState: IInitialSliceState = {
  status: null,
  error: null,
  reqId: null,
  msg: null
};

interface IAlertActionResponse {
  message: string
}

export const alertAction = createAsyncThunk(ALERT_ACTION, async (payload: any, { rejectWithValue }) => {
    try {
      const response = await api.post<IAlertActionResponse>(quickAlertsUrl, payload);
      const alertActionResponse: IAlertActionResponse = response.data;
      return alertActionResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const alertActionSlice = createSlice({
  name: ALERT_ACTION,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(alertAction.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(alertAction.fulfilled, (state, action) => {
        state.msg = action.payload.message
        state.status = Status.SUCCESS
      })
      .addCase(alertAction.rejected, (state, action) => {
        const errorPayload = action.payload as { response?: { data?: { error?: { message?: string }, message?: string } } };
        state.msg = errorPayload.response?.data?.error?.message || errorPayload.response?.data?.message || 'Unknown error occurred';
        state.reqId = Math.random()
        state.status = Status.FAILED
      });
  },
});

export const selector = (state: RootState) => state.alertAction;

export const reducer = alertActionSlice.reducer;